import { cva } from 'class-variance-authority';

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: {
      large: 'text-size-h2 ml-[0.7rem]',
      normal: 'text-size-h4 ml-[0.6rem]',
      small: 'text-size-h5 ml-[0.5rem]',
    },
  },
  defaultVariants: { size: 'normal' },
});
